<template>
    <button class="my-button">{{ text }}</button>
</template>

<script>
export default {
    name: "MyButton",
    props: ["text"],
};
</script>

<style lang="scss">
.my-button {
    position: relative;
    color: #fff;
    font-size: 18px;
    text-decoration: none;
    margin: 30px 0;
    border: 2px solid #fff;
    padding: 15px 30px;
    overflow: hidden;
    transition: .6s all ease;
    background: transparent;
    border-radius: 10px;
    z-index: 100000;
}
@media (max-width: 991px) {
    .my-button{
        font-size: 16px;
    }
}
.my-button::before {
    background: #fff;
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all .6s ease;
}

.my-button:hover {
    color: var(--main-blue);
}

.my-button::before {
    width: 0%;
    height: 102%;
}

.my-button:hover::before {
    width: 101%;
}
</style>
